module.exports = __webpack_public_path__ + "img/57_25.bd97f62c.png";